import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Namespace Imports",
description: "Learn how to extend visibility in Freon by importing namespaces, define inheritance-like behavior, use recursive imports, and control visibility with public and private properties.",
tags: [ "namespace imports", "scoping", "visibility", "recursive imports", "private properties", "Freon", "DSL development", "scope rules"] ,
modifiedTime: "2025-11-07T17:39:02.373Z",
publishedTime: "2025-11-07T17:20:18.623Z"
    }
  };
};